"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListaConteudo = void 0;
var react_1 = __importDefault(require("react"));
var Divider_1 = require("../../Divider/Divider");
var Paginacao_1 = require("../../Paginacao/Paginacao");
var ItemConteudo_1 = require("../ItemConteudo/ItemConteudo");
var uuid_1 = require("uuid");
var cardListaResultadoBuscaModule = require("../CardListaResultadoBusca.module.scss");
var ListaConteudo = function (props) {
    var _a, _b;
    var totalItens = (_a = props.quantidadeTotalItens) !== null && _a !== void 0 ? _a : props.itens.length;
    return (react_1.default.createElement(react_1.default.Fragment, null, (_b = props.itens) === null || _b === void 0 ? void 0 :
        _b.map(function (item, index) {
            var _a, _b;
            return (react_1.default.createElement("div", { key: (0, uuid_1.v4)() },
                react_1.default.createElement(ItemConteudo_1.ItemConteudo, { key: (0, uuid_1.v4)(), item: item }, (_b = (_a = props.itemChildren) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : null),
                react_1.default.createElement("div", { key: (0, uuid_1.v4)(), className: cardListaResultadoBuscaModule.divider },
                    react_1.default.createElement(Divider_1.Divider, { key: (0, uuid_1.v4)() }))));
        }),
        props.itens.length > 0 &&
            react_1.default.createElement(Paginacao_1.Paginacao, { totalItens: totalItens, itensPorPagina: props.quantidadePorPagina, paginaAtual: props.paginaAtual, onItensPorPaginaChange: props.onChangeQuantidadePorPagina, onPageChange: props.onChangePagina, opcoesItensPorPagina: props.opcoesItensPorPagina })));
};
exports.ListaConteudo = ListaConteudo;
